import Api from '@/services/Api'

export default {
	getSession() {
		return Api().get('session')
	},
	logout() {
		return Api().get('logout')
	}
}
